//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../Assemblies/Assemblies.SelectComponent.js";
import "../no/SelectBodyList.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Associative",1,0],[0,"CloneObject",0,"Tooling.CloneObject",0],[0,"CopyDestinationSelection",1,0],[1,"DestinationComponent",0,"Assemblies.SelectComponent",0],[0,"FixAtCurrentTimestamp",1,0],[0,"MultipleComponents",1,0],[0,"OriginalBodyLayer",1,0],[0,"OriginalBodyOperation",1,0],[1,"SelectBodies",0,"SelectBodyList",0],[1,"SelectParentPartOcc",0,"Assemblies.SelectComponent",0],[0,"TemplateNameListValue",1,0],[0,"WizardType",1,0]],[[[],"GetParentFromConfigurationRecord",{R_:{parentName:''}},0,0],[[],"UpdateCloneItemsName",{},0,0],[["templateName","attributeName","attributeValue","deleteAttr"],"SetTemplateAttribute",{},4,0],[[],"ClearPartItems",{},0,0],[["isDefinedParent"],"SetIsDefinedParent",{},1,0],[["updateType"],"UpdateClonePartItems",{},1,0]],[]];
SPLM.Tooling.CopySolidBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.CopySolidBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.CopySolidBuilder.CopyDestinationType = Object.freeze({
    "NewComponent" : "NewComponent", "NewComponentFromAttribute" : "NewComponentFromAttribute", "ExistingComponent" : "ExistingComponent"});

SPLM.Tooling.CopySolidBuilder.OriginalOperationOption = Object.freeze({
    "None" : "None", "Hide" : "Hide", "MoveToLayer" : "MoveToLayer", "Delete" : "Delete"});

SPLM.Tooling.CopySolidBuilder.PartItemUpdateType = Object.freeze({
    "Restore" : "Restore", "Rebuild" : "Rebuild"});

export default SPLM;